import script from "./MapSingleNewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MapSingleNewsCard.vue?vue&type=script&setup=true&lang=js"

import "./MapSingleNewsCard.vue?vue&type=style&index=0&id=3caca4aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3caca4aa"]])

export default __exports__